import { render, staticRenderFns } from "./HomepageOverlay.vue?vue&type=template&id=ec281aa6&"
import script from "./HomepageOverlay.vue?vue&type=script&lang=js&"
export * from "./HomepageOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports